"use strict";
import { BaseTransport } from "@amplitude/analytics-core";
export var OriginApplication = /* @__PURE__ */ ((OriginApplication2) => {
  OriginApplication2["DOCS"] = "docs";
  OriginApplication2["INFO"] = "info";
  OriginApplication2["INTERFACE"] = "interface";
  OriginApplication2["MOBILE"] = "mobile-analytics-uniswap";
  OriginApplication2["ORG"] = "org";
  return OriginApplication2;
})(OriginApplication || {});
export class ApplicationTransport extends BaseTransport {
  constructor(originApplication, reportOriginCountry) {
    super();
    this.originApplication = originApplication;
    this.reportOriginCountry = reportOriginCountry;
    if (typeof fetch === "undefined") {
      throw new Error("FetchTransport is not supported");
    }
  }
  shouldReportOriginCountry = true;
  async send(serverUrl, payload) {
    const request = {
      headers: {
        "x-origin-application": this.originApplication,
        "Content-Type": "application/json",
        Accept: "*/*"
      },
      keepalive: true,
      // allow the request to outlive the page
      body: JSON.stringify(payload),
      method: "POST"
    };
    const response = await fetch(serverUrl, request);
    const responseJSON = await response.json();
    if (response.headers.has("Origin-Country") && this.shouldReportOriginCountry) {
      if (this.reportOriginCountry) {
        this.reportOriginCountry(response.headers.get("Origin-Country"));
      }
      this.shouldReportOriginCountry = false;
    }
    return this.buildResponse(responseJSON);
  }
}
